import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Heading,
  Input,
  useColorModeValue,
  Text,
  useToast,
} from '@chakra-ui/react';
import { authRepository } from 'api/authRepository';

import CenteredAuth from 'layouts/auth/variants/Centered';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { contactEmailSchema } from 'validations/Validations';

function ForgotPassword() {
  const toast = useToast();
  const navigate = useNavigate();

  const textColor = useColorModeValue('navy.700', 'white');
  const textColorSecondary = 'gray.400';
  const brandStars = useColorModeValue('brand.500', 'brand.400');


  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleEmailChange = (value: string) => {
    setEmail(value);

    const result = contactEmailSchema.safeParse(value);
    setError(result.success ? '' : result.error.issues[0].message);
  };

  // Submit
  const handleSubmit = async () => {
    const result = contactEmailSchema.safeParse(email);

    if (!result.success) {
      setError(result.error.issues[0].message);
      return;
    }

    try {
      const response = await authRepository.forgotpassword(email);
      console.log('Password reset request successful:', response);
      navigate('/auth/new-password');
    } catch (err) {
      toast({
        title: 'Error',
        description: 'Failed to send password reset request.',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
    }
  };

  return (
    <CenteredAuth
      cardTop={{ base: '140px', md: '24vh' }}
      cardBottom={{ base: '50px', lg: 'auto' }}
    >
      <Flex
        w="100%"
        maxW="max-content"
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        px={{ base: '25px', md: '0px' }}
        flexDirection="column"
      >
        <Box me="auto" mb="34px">
          <Heading
            color={textColor}
            fontSize={{ base: '3xl', md: '36px' }}
            mb="16px"
          >
            Forgot your password?
          </Heading>
          <Text
            color={textColorSecondary}
            fontSize="md"
            w={{ base: '100%', lg: '456px' }}
            maxW="100%"
          >
            No problem. Just let us know your email address and we'll email you
            a password reset link that will allow you to choose a new one.
          </Text>
        </Box>
        <Flex
          zIndex="2"
          direction="column"
          w={{ base: '100%', lg: '456px' }}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{ base: 'auto', lg: 'unset' }}
          me="auto"
          mb={{ base: '20px', md: 'auto' }}
          align="start"
        >
          <FormControl isInvalid={!!error}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Email<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              isRequired
              variant="auth"
              fontSize="sm"
              type="email"
              placeholder="mail@simmmple.com"
              mb="8px"
              size="lg"
              value={email}
              onChange={(e) => handleEmailChange(e.target.value)}
            />
            {error && <FormErrorMessage mb="16px">{error}</FormErrorMessage>}
            <Button
              fontSize="sm"
              variant="brand"
              fontWeight="500"
              w="100%"
              h="50"
              mt="16px"
              onClick={handleSubmit}
            >
              Email password reset link
            </Button>
          </FormControl>
        </Flex>
      </Flex>
    </CenteredAuth>
  );
}

export default ForgotPassword;
